import { atom } from 'recoil';

const stateResultMode = atom({
  key: 'results.mode',
  default: 'genomic',
});

export default stateResultMode;
